import { areArraysShallowEqual } from './areShallowEqual';
export function createMemo() {
    var memo = function (compute, deps) {
        if (process.env.NODE_ENV !== 'production') {
            if (!Array.isArray(deps)) {
                throw new Error('The memo function returned by createMemo() must receive a deps array as its second arumgent.');
            }
        }
        if (!memo.last || !areArraysShallowEqual(deps, memo.last[1])) {
            memo.last = [compute(), deps];
        }
        return memo.last[0];
    };
    return memo;
}
export function createWeakMemo() {
    var weakMap = new WeakMap();
    var memo = function (compute, weakDeps, deps) {
        if (deps === void 0) { deps = []; }
        var head = weakDeps[0], tail = weakDeps.slice(1);
        if (process.env.NODE_ENV !== 'production') {
            var headType = typeof head;
            if (head === null || !['object', 'function'].includes(headType)) {
                throw new Error("The memo function returned by createWeakMemo() must receive only objects or functions in its first deps array. Instead received: \"" + headType + "\".");
            }
        }
        var childMemo = weakMap.get(head);
        if (!childMemo) {
            childMemo = tail.length
                ? createWeakMemo()
                : createMemo();
            weakMap.set(head, childMemo);
        }
        return childMemo(compute, tail.length ? tail : deps, deps);
    };
    return memo;
}
